import type { Control, FieldErrors } from 'react-hook-form';
import { useFieldArray } from 'react-hook-form';
import type { VacationRequestFormValues } from '../../../models/vacation.schemas';

export interface UseClientEmailFieldsParams {
    control: Control<VacationRequestFormValues>;
    errors: FieldErrors<VacationRequestFormValues>;
}

export function useClientEmailFields({ control, errors }: UseClientEmailFieldsParams) {
    const { fields, append, remove } = useFieldArray({ control, name: 'clientEmails' });

    const clientEmails = fields.map((field) => (field as any).value as string).filter((email) => email !== '');

    const clientEmailsError = (errors.clientEmails?.message as string) ?? undefined;

    const addClientEmail = (email: string) => {
        append({ value: email }, { shouldFocus: false });
    };

    const removeClientEmail = (index: number) => {
        remove(index);
    };

    return {
        clientEmails,
        clientEmailsError,
        addClientEmail,
        removeClientEmail,
    };
}
